import React from 'react';
import Style from './Card.module.css'
import { NavLink } from 'react-router-dom';

export default function Card(props) {
  // acá va tu código
  const {name, min , max , img, onClose, id} = props
  const {card , content , button , contenedor,titleLink} = Style
  return (
      <div className={card}>
        <div className={content}>
          <span onClick={onClose} className={button}>x</span>
        </div>
      
        <NavLink to ={`/ciudad/${id}`} className={titleLink}>
          <h1>{name.length > 0? name : 'Nombre de la ciudad'}</h1>
        </NavLink>
        <div className={contenedor}>
          <div className="min">
            <h3>Min</h3>
            <p>{min}</p>
          </div>

          <div className="max">
            <h3>Max</h3>
            <p>{max}</p>
          </div>

          <img src={`http://openweathermap.org/img/wn/${img}@2x.png`} alt={`clima de la ciudad ${name}`} />
        </div>
    </div>
  )
  
};